import { css } from '@emotion/react';

export const card_detail_item_title = css`
  text-transform: uppercase;
`;
